import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { ReactComponent as SearchSvg } from './icons/search.svg';
import { ReactComponent as SortSvg } from './icons/arrows-vertical.svg';
import { ReactComponent as ArrowUpSvg } from './icons/arrow-up.svg';
import { ReactComponent as ArrowDownSvg } from './icons/arrow-down.svg';
import { ReactComponent as ArrowRightSvg } from './icons/arrow-right.svg';
import { ReactComponent as ArrowLeftSvg } from './icons/arrow-left.svg';
import { ReactComponent as DownloadSvg } from './icons/download.svg';
import { ReactComponent as FilterSvg } from './icons/filter.svg';
import { ReactComponent as FilterRemoveSvg } from './icons/filter-remove.svg';
import { ReactComponent as MenuSvg } from './icons/menu.svg';
import { ReactComponent as CaretLeftSvg } from './icons/caret-left.svg';
import { ReactComponent as CaretRightSvg } from './icons/caret-right.svg';
import { ReactComponent as CrossSvg } from './icons/cross.svg';
import { ReactComponent as CalendarSvg } from './icons/calendar.svg';
import { ReactComponent as UserSvg } from './icons/user.svg';
import { ReactComponent as HistorySvg } from './icons/recently-viewed.svg';
import { ReactComponent as ResetSvg } from './icons/reset.svg';
import { ReactComponent as AddCommentSvg } from './icons/add-comment.svg';
import { ReactComponent as CommentSvg } from './icons/comment.svg';
import { ReactComponent as EditSvg } from './icons/edit.svg';
import { ReactComponent as RefreshSvg } from './icons/refresh.svg';
import { ReactComponent as PlusSvg } from './icons/plus.svg';
import { ReactComponent as ActiveListSvg } from './icons/active-list.svg';
import { ReactComponent as QuestionSvg } from './icons/question.svg';
import { ReactComponent as SuccessSvg } from './icons/success.svg';
import { ReactComponent as BanSvg } from './icons/ban.svg';
import { ReactComponent as WarningFilledSvg } from './icons/warning-filled.svg';
import { ReactComponent as WarningOutlinedSvg } from './icons/warning-outlined.svg';
import { ReactComponent as WarningCircleSvg } from './icons/warning.svg';
import { ReactComponent as InfoOutlinedSvg } from './icons/information.svg';
import { ReactComponent as SuccessOutlinedSvg } from './icons/success-outlined.svg';
import { ReactComponent as MaximizeSvg } from './icons/maximize.svg';
import { ReactComponent as DeleteSvg } from './icons/delete.svg';
import { ReactComponent as ArchiveSvg } from './icons/archive.svg';
import { ReactComponent as SettingsAdjustSvg } from './icons/settings-adjust.svg';
import { ReactComponent as AppsSvg } from './icons/apps.svg';
import { ReactComponent as ChevronDownSvg } from './icons/chevron-down.svg';
import { ReactComponent as ChevronUpSvg } from './icons/chevron-up.svg';
import { ReactComponent as NotificationErrorSvg } from './icons/notification-error.svg';
import { ReactComponent as NotificationWarningSvg } from './icons/warning.svg';
import { ReactComponent as SelectableCardSelectedSvg } from './icons/selectable-card-selected.svg';
import { ReactComponent as InfoSvg } from './icons/info.svg';
import { ReactComponent as EventSvg } from './icons/event--schedule.svg';
import { ReactComponent as CopySvg } from './icons/copy.svg';
import { ReactComponent as SaveSvg } from './icons/save.svg';

import { ReactComponent as StepperIndicatorCurrentSvg } from './icons/stepper-indicator-current.svg';
import { ReactComponent as StepperIndicatorDefaultSvg } from './icons/stepper-indicator-default.svg';
import { ReactComponent as StepperIndicatorPassedSvg } from './icons/stepper-indicator-passed.svg';

import { ReactComponent as SelectDownSvg } from './icons/select-down.svg';
import { ReactComponent as SelectSelectedSvg } from './icons/select-selected.svg';

import { ReactComponent as ConfigurationSvg } from './icons/configuration.svg';
import { ReactComponent as HWRSvg } from './icons/hwr.svg';
import { ReactComponent as ForecastSvg } from './icons/forecast.svg';
import { ReactComponent as CadenceSvg } from './icons/cadence.svg';
import { ReactComponent as EntitlementsSvg } from './icons/entitlements.svg';
import { ReactComponent as RenewalsSvg } from './icons/renewals.svg';
import { ReactComponent as SalesplaySvg } from './icons/salesplay.svg';
import { ReactComponent as CompetetiveTakeoutSvg } from './icons/competitive-takeout.svg';
import { ReactComponent as HelpSvg } from './icons/help.svg';
import { ReactComponent as InfoFilledSvg } from './icons/information-filled.svg';
import { ReactComponent as SlackSvg } from './icons/slack.svg';
import { ReactComponent as ExternalLinkSvg } from './icons/externalLink.svg';
import { ReactComponent as LetterSvg } from './icons/letter.svg';
import { ReactComponent as SupportSvg } from './icons/support.svg';

import { ReactComponent as UserMultipleSvg } from './icons/user-multiple.svg';
import { ReactComponent as OrderDetailsSvg } from './icons/order-details.svg';
import { ReactComponent as BareMetalServerSvg } from './icons/bare-metal-server.svg';
import { ReactComponent as DataStructuredSvg } from './icons/data-structured.svg';
import { ReactComponent as FireWallClassicSvg } from './icons/firewall-classic.svg';
import { ReactComponent as PartnershipSvg } from './icons/partnership.svg';
import { ReactComponent as UsageReportSvg } from './icons/usage-report.svg';
import { ReactComponent as EpsAndFlowsSvg } from './icons/eps-and-flows.svg';
import { ReactComponent as QradarSvg } from './icons/qradar.svg';
import { ReactComponent as EmailSvg } from './icons/email.svg';

import { ReactComponent as HomeSvg } from './icons/home.svg';
import { ReactComponent as ListSvg } from './icons/list.svg';
import { ReactComponent as NewTabSvg } from './icons/new-tab.svg';

import { ReactComponent as AddSvg } from './icons/add.svg';
import { ReactComponent as ReplaceFlmSvg } from './icons/replace-flm.svg';
import { ReactComponent as TransferDataSvg } from './icons/transfer-data.svg';

import { ReactComponent as DocumentImportSvg } from './icons/document--import.svg';

export const SearchIcon = props => (
  <SvgIcon {...props}>
    <SearchSvg />
  </SvgIcon>
);

export const SortIcon = props => (
  <SvgIcon {...props}>
    <SortSvg />
  </SvgIcon>
);

export const DownloadIcon = props => (
  <SvgIcon {...props}>
    <DownloadSvg />
  </SvgIcon>
);

export const FilterIcon = props => (
  <SvgIcon {...props}>
    <FilterSvg />
  </SvgIcon>
);

export const FilterRemoveIcon = props => (
  <SvgIcon {...props}>
    <FilterRemoveSvg />
  </SvgIcon>
);

export const ArrowUpIcon = props => (
  <SvgIcon {...props}>
    <ArrowUpSvg />
  </SvgIcon>
);

export const ArrowDownIcon = props => (
  <SvgIcon {...props}>
    <ArrowDownSvg />
  </SvgIcon>
);

export const ArrowRightIcon = props => (
  <SvgIcon {...props}>
    <ArrowRightSvg />
  </SvgIcon>
);

export const ArrowLeftIcon = props => (
  <SvgIcon {...props}>
    <ArrowLeftSvg />
  </SvgIcon>
);

export const MenuIcon = props => (
  <SvgIcon {...props}>
    <MenuSvg />
  </SvgIcon>
);

export const CaretLeftIcon = props => (
  <SvgIcon {...props}>
    <CaretLeftSvg />
  </SvgIcon>
);

export const CaretRightIcon = props => (
  <SvgIcon {...props}>
    <CaretRightSvg />
  </SvgIcon>
);

export const CrossIcon = props => (
  <SvgIcon {...props}>
    <CrossSvg />
  </SvgIcon>
);

export const Calendar = props => (
  <SvgIcon {...props}>
    <CalendarSvg />
  </SvgIcon>
);

export const UserIcon = props => (
  <SvgIcon {...props}>
    <UserSvg />
  </SvgIcon>
);

export const HistoryIcon = props => (
  <SvgIcon {...props}>
    <HistorySvg />
  </SvgIcon>
);

export const ResetIcon = props => (
  <SvgIcon {...props}>
    <ResetSvg />
  </SvgIcon>
);

export const AddCommentIcon = props => (
  <SvgIcon {...props}>
    <AddCommentSvg />
  </SvgIcon>
);

export const CommentIcon = props => (
  <SvgIcon {...props}>
    <CommentSvg />
  </SvgIcon>
);

export const EditIcon = props => <EditSvg {...props} />;

export const RefreshIcon = props => (
  <SvgIcon {...props}>
    <RefreshSvg />
  </SvgIcon>
);

export const PlusIcon = props => (
  <SvgIcon {...props}>
    <PlusSvg />
  </SvgIcon>
);

export const ActiveListIcon = props => (
  <SvgIcon {...props}>
    <ActiveListSvg />
  </SvgIcon>
);

export const QuestionIcon = props => (
  <SvgIcon {...props}>
    <QuestionSvg />
  </SvgIcon>
);

export const SuccessIcon = props => (
  <SvgIcon {...props}>
    <SuccessSvg />
  </SvgIcon>
);

export const BanIcon = props => (
  <SvgIcon {...props}>
    <BanSvg />
  </SvgIcon>
);

export const WarningFilledIcon = props => <WarningFilledSvg {...props} />;

export const WarningOutlinedIcon = props => (
  <SvgIcon {...props}>
    <WarningOutlinedSvg />
  </SvgIcon>
);

export const WarningCircleIcon = props => (
  <SvgIcon {...props}>
    <WarningCircleSvg />
  </SvgIcon>
);

export const InfoOutlinedIcon = props => (
  <SvgIcon {...props}>
    <InfoOutlinedSvg />
  </SvgIcon>
);

export const SuccessOutlinedIcon = props => (
  <SvgIcon {...props}>
    <SuccessOutlinedSvg />
  </SvgIcon>
);

export const MaximizeIcon = props => (
  <SvgIcon {...props}>
    <MaximizeSvg />
  </SvgIcon>
);

export const DeleteIcon = props => (
  <SvgIcon {...props}>
    <DeleteSvg />
  </SvgIcon>
);

export const ArchiveIcon = props => (
  <SvgIcon {...props}>
    <ArchiveSvg />
  </SvgIcon>
);

export const SettingsAdjustIcon = props => (
  <SvgIcon {...props}>
    <SettingsAdjustSvg />
  </SvgIcon>
);

export const AppsIcon = props => (
  <SvgIcon {...props}>
    <AppsSvg />
  </SvgIcon>
);

export const ChevronDownIcon = props => (
  <SvgIcon {...props}>
    <ChevronDownSvg />
  </SvgIcon>
);

export const ChevronUpIcon = props => (
  <SvgIcon {...props}>
    <ChevronUpSvg />
  </SvgIcon>
);

export const NotificationErrorIcon = props => (
  <SvgIcon {...props}>
    <NotificationErrorSvg />
  </SvgIcon>
);

export const NotificationWarningIcon = props => (
  <SvgIcon {...props}>
    <NotificationWarningSvg />
  </SvgIcon>
);

export const SelectableCardSelectedIcon = props => (
  <SvgIcon {...props}>
    <SelectableCardSelectedSvg />
  </SvgIcon>
);

export const InfoIcon = props => (
  <SvgIcon {...props}>
    <InfoSvg />
  </SvgIcon>
);

export const EventIcon = props => (
  <SvgIcon {...props}>
    <EventSvg />
  </SvgIcon>
);

export const CopyIcon = props => (
  <SvgIcon {...props}>
    <CopySvg />
  </SvgIcon>
);

export const SaveIcon = props => (
  <SvgIcon {...props}>
    <SaveSvg />
  </SvgIcon>
);

export const StepperIndicatorCurrentIcon = props => (
  <SvgIcon {...props}>
    <StepperIndicatorCurrentSvg />
  </SvgIcon>
);

export const StepperIndicatorDefaultIcon = props => (
  <SvgIcon {...props}>
    <StepperIndicatorDefaultSvg />
  </SvgIcon>
);

export const StepperIndicatorPassedIcon = props => (
  <SvgIcon {...props}>
    <StepperIndicatorPassedSvg />
  </SvgIcon>
);

export const SelectDownIcon = props => (
  <SvgIcon {...props}>
    <SelectDownSvg />
  </SvgIcon>
);

export const SelectSelectedIcon = props => (
  <SvgIcon {...props}>
    <SelectSelectedSvg />
  </SvgIcon>
);

export const NewTabIcon = props => (
  <SvgIcon {...props}>
    <NewTabSvg />
  </SvgIcon>
);

export const HomeIcon = props => (
  <SvgIcon {...props}>
    <HomeSvg />
  </SvgIcon>
);

export const ListIcon = props => (
  <SvgIcon {...props}>
    <ListSvg />
  </SvgIcon>
);

export const AddIcon = props => <AddSvg {...props} />;
export const ReplaceFlmIcon = props => <ReplaceFlmSvg {...props} />;
export const TransferDataIcon = props => <TransferDataSvg {...props} />;

export const ConfigurationIcon = props => <ConfigurationSvg {...props} />;
export const HWRIcon = props => <HWRSvg {...props} />;
export const ForecastIcon = props => <ForecastSvg {...props} />;
export const CadenceIcon = props => <CadenceSvg {...props} />;
export const EntitlementsIcon = props => <EntitlementsSvg {...props} />;
export const RenewalsIcon = props => <RenewalsSvg {...props} />;
export const SalesplayIcon = props => <SalesplaySvg {...props} />;
export const CompetetiveTakeoutIcon = props => <CompetetiveTakeoutSvg {...props} />;
export const HelpIcon = props => <HelpSvg {...props} />;
export const InfoFilledIcon = props => <InfoFilledSvg {...props} />;
export const SlackIcon = props => <SlackSvg {...props} />;
export const ExternalLinkIcon = props => <ExternalLinkSvg {...props} />;
export const LetterIcon = props => <LetterSvg {...props} />;
export const SupportIcon = props => <SupportSvg {...props} />;

export const UserMultipleIcon = props => <UserMultipleSvg {...props} />;
export const OrderDetailsIcon = props => <OrderDetailsSvg {...props} />;
export const QRadarReportIcon = props => <BareMetalServerSvg {...props} />;
export const CommonReportIcon = props => <DataStructuredSvg {...props} />;
export const GuardiumReportIcon = props => <FireWallClassicSvg {...props} />;
export const BPReportIcon = props => <PartnershipSvg {...props} />;
export const UsageReportIcon = props => <UsageReportSvg {...props} />;
export const EpsAndFlowsIcon = props => <EpsAndFlowsSvg {...props} />;
export const QradarIcon = props => <QradarSvg {...props} />;

export const EmailIcon = props => (
  <SvgIcon {...props}>
    <EmailSvg />
  </SvgIcon>
);

export const DocumentImportIcon = props => (
  <SvgIcon {...props}>
    <DocumentImportSvg />
  </SvgIcon>
);
